import { AppState } from '../rootReducer';

export const refundsChargebacksSelectors = {
  getSummary: (state: AppState) => state.refundsChargebacks.summary,
  getCards: (state: AppState) => state.refundsChargebacks.cards,
  getTransactionsRefunded: (state: AppState) => state.refundsChargebacks.transactionsRefunded,
  getTransactionsRefundRates: (state: AppState) => state.refundsChargebacks.transactionsRefundRates,
  getTransactionsChargebackRates: (state: AppState) => state.refundsChargebacks.transactionsChargebackRates
};
